
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import isEqual from 'lodash/isEqual';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import Vue from 'vue';
import get from 'lodash/get';

var script = {
  name: 'Skeleton',
  inheritAttrs: false,
  props: {
    skeletonProps: {
      type: Object,
      default: () => ({})
    },
    containerWidth: {
      type: [Number, String],
      default: 0
    },
    containerHeight: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    clipId() {
      return this.uid();
    },

    gradientId() {
      return this.uid();
    },

    viewBox() {
      const containerWidth = this.containerWidth,
            containerHeight = this.containerHeight;
      return `0 0 ${containerWidth} ${containerHeight}`;
    }

  },
  methods: {
    uid() {
      return Math.random().toString(36).substring(2);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    style: {
      maxWidth: '100%'
    },
    attrs: {
      "width": _vm.containerWidth,
      "height": _vm.containerHeight
    }
  }, [_c('svg', {
    class: _vm.skeletonProps.class,
    attrs: {
      "viewBox": _vm.viewBox,
      "preserveAspectRatio": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("\n            Loading...\n        ")]), _vm._v(" "), _c('rect', {
    style: {
      fill: "url(#" + _vm.gradientId + ")"
    },
    attrs: {
      "clip-path": "url(#" + _vm.clipId + ")",
      "width": "100%",
      "height": "100%",
      "x": "0",
      "y": "0"
    }
  }), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": _vm.clipId
    }
  }, [_c('rect', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "rx": _vm.skeletonProps.borderRadius + "px",
      "ry": _vm.skeletonProps.borderRadius + "px",
      "x": "0",
      "y": "0"
    }
  })]), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": _vm.gradientId
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": _vm.skeletonProps.primaryColor,
      "offset": "0%"
    }
  }, [_vm.skeletonProps.animate ? _c('animate', {
    attrs: {
      "dur": _vm.skeletonProps.speed + "s",
      "attributeName": "offset",
      "values": "-2; 1",
      "repeatCount": "indefinite"
    }
  }) : _vm._e()]), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": _vm.skeletonProps.secondaryColor,
      "offset": "50%"
    }
  }, [_vm.skeletonProps.animate ? _c('animate', {
    attrs: {
      "dur": _vm.skeletonProps.speed + "s",
      "attributeName": "offset",
      "values": "-1.5; 1.5",
      "repeatCount": "indefinite"
    }
  }) : _vm._e()]), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": _vm.skeletonProps.primaryColor,
      "offset": "100%"
    }
  }, [_vm.skeletonProps.animate ? _c('animate', {
    attrs: {
      "dur": _vm.skeletonProps.speed + "s",
      "attributeName": "offset",
      "values": "-1; 2",
      "repeatCount": "indefinite"
    }
  }) : _vm._e()])], 1)], 1)])]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "skeleton.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var SkeletonLoader = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var script$1 = {
  name: 'Feather',
  inheritAttrs: false,
  props: {
    spinnerProps: {
      type: Object,
      default: () => ({})
    }
  }
};

const __vue_script__$1 = script$1;

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.spinnerProps.class,
    style: {
      color: _vm.spinnerProps.color
    }
  }, [_c('svg', {
    attrs: {
      "width": _vm.spinnerProps.size + "px",
      "height": _vm.spinnerProps.size + "px",
      "stroke": "currentColor",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('line', {
    attrs: {
      "id": "line-1",
      "x1": "12",
      "y1": "2",
      "x2": "12",
      "y2": "6"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "from": "1",
      "to": "0.2",
      "dur": "0.8s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "id": "line-2",
      "x1": "16.24",
      "y1": "7.76",
      "x2": "19.07",
      "y2": "4.93"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "from": "1",
      "to": "0.2",
      "dur": "0.8s",
      "begin": "0.1s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "id": "line-3",
      "x1": "18",
      "y1": "12",
      "x2": "22",
      "y2": "12"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "from": "1",
      "to": "0.2",
      "dur": "0.8s",
      "begin": "0.2s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "id": "line-4",
      "x1": "16.24",
      "y1": "16.24",
      "x2": "19.07",
      "y2": "19.07"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "from": "1",
      "to": "0.2",
      "dur": "0.8s",
      "begin": "0.3s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "id": "line-5",
      "x1": "12",
      "y1": "18",
      "x2": "12",
      "y2": "22"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "from": "1",
      "to": "0.2",
      "dur": "0.8s",
      "begin": "0.4s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "id": "line-6",
      "x1": "4.93",
      "y1": "19.07",
      "x2": "7.76",
      "y2": "16.24"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "from": "1",
      "to": "0.2",
      "dur": "0.8s",
      "begin": "0.5s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "id": "line-7",
      "x1": "2",
      "y1": "12",
      "x2": "6",
      "y2": "12"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "from": "1",
      "to": "0.2",
      "dur": "0.8s",
      "begin": "0.6s",
      "repeatCount": "indefinite"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "id": "line-8",
      "x1": "4.93",
      "y1": "4.93",
      "x2": "7.76",
      "y2": "7.76"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "opacity",
      "from": "1",
      "to": "0.2",
      "dur": "0.8s",
      "begin": "0.7s",
      "repeatCount": "indefinite"
    }
  })])])]);
};

var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_is_functional_template__$1 = false;

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "feather.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var Feather = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1);

var script$2 = {
  name: 'Material',
  inheritAttrs: false,
  props: {
    spinnerProps: {
      type: Object,
      default: () => ({})
    }
  }
};

const __vue_script__$2 = script$2;

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-loading--material",
    class: _vm.spinnerProps.class,
    style: {
      color: _vm.spinnerProps.color
    }
  }, [_c('svg', {
    staticClass: "pendo-loading__svg",
    attrs: {
      "stroke": "currentColor",
      "width": _vm.spinnerProps.size + "px",
      "height": _vm.spinnerProps.size + "px",
      "viewBox": "0 0 66 66",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "pendo-loading__path",
    attrs: {
      "fill": "none",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "cx": "33",
      "cy": "33",
      "r": "30"
    }
  })])]);
};

var __vue_staticRenderFns__$2 = [];
const __vue_inject_styles__$2 = undefined;
const __vue_scope_id__$2 = undefined;
const __vue_is_functional_template__$2 = false;

function __vue_normalize__$2(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "material.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var Material = __vue_normalize__$2({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2);

var script$3 = {
  name: 'Loading',
  components: {
    Skeleton: SkeletonLoader,
    Feather,
    Material
  },

  data() {
    return {
      visible: false,
      hiding: false,
      containerWidth: 0,
      containerHeight: 0
    };
  },

  computed: {
    overlayStyle() {
      const type = this.type,
            spinnerProps = this.spinnerProps,
            overlayProps = this.overlayProps;

      if (type === 'skeleton') {
        return {
          position: overlayProps.position || 'absolute'
        };
      }

      return {
        'background-color': spinnerProps.background,
        position: overlayProps.position || 'absolute',
        'justify-content': 'center',
        'grid-gap': '8px'
      };
    }

  },
  methods: {
    setContainerSize({
      width,
      height
    }) {
      this.containerHeight = height;
      this.containerWidth = width;
    }

  }
};

const __vue_script__$3 = script$3;

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "appear": "",
      "name": _vm.overlayProps.transition
    },
    on: {
      "after-leave": function ($event) {
        _vm.hiding = false;
      }
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "pendo-loading",
    class: [_vm.overlayProps.class, {
      'pendo-loading--text': _vm.text
    }],
    style: _vm.overlayStyle
  }, [_c(_vm.type, {
    tag: "component",
    attrs: {
      "container-width": _vm.containerWidth,
      "container-height": _vm.containerHeight,
      "skeleton-props": _vm.skeletonProps,
      "spinner-props": _vm.spinnerProps
    }
  }), _vm._v(" "), _vm.text ? _c('div', {
    class: _vm.textClass
  }, [_vm._v("\n            " + _vm._s(_vm.text) + "\n        ")]) : _vm._e()], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$3 = [];
const __vue_inject_styles__$3 = undefined;
const __vue_scope_id__$3 = undefined;
const __vue_is_functional_template__$3 = false;

function __vue_normalize__$3(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "loading.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var LoadingComponent = __vue_normalize__$3({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3);

const Loader = Vue.extend(LoadingComponent);
const LOADING_DEFAULTS = {
  type: 'skeleton',
  textClass: 'pendo-loading-text',
  overlayProps: {
    class: 'pendo-loading-overlay',
    transition: 'pendo-loading-fade'
  },
  spinnerProps: {
    class: 'pendo-loading-spinner',
    color: '#2a2c35',
    background: '#f4f4f7',
    size: 24
  },
  skeletonProps: {
    class: 'pendo-loading-skeleton',
    speed: 2,
    borderRadius: 3,
    animate: true,
    primaryColor: '#eaecf1',
    secondaryColor: '#f8f8f9'
  }
};
function getOptions(options) {
  return {
    type: options.type || PendoLoading.options.type,
    text: options.text || PendoLoading.options.text,
    textClass: options.textClass || PendoLoading.options.textClass,
    preventRelativeParent: options.preventRelativeParent || PendoLoading.options.preventRelativeParent,
    overlayProps: _objectSpread({}, PendoLoading.options.overlayProps, options.overlayProps),
    spinnerProps: _objectSpread({}, PendoLoading.options.spinnerProps, options.spinnerProps),
    skeletonProps: _objectSpread({}, PendoLoading.options.skeletonProps, options.skeletonProps)
  };
}
function getLoadingValue(value) {
  const type = typeof value;

  if (type === typeof true) {
    return value;
  }

  if (value && type === 'object') {
    return value.loading;
  }

  return false;
}
function insertDom(el) {
  if (!el.domVisible && el.style.display !== 'none' && el.style.visibility !== 'hidden') {
    if (!['absolute', 'fixed'].includes(el.originalPosition) && !el.instance.preventRelativeParent) {
      el.classList.add('pendo-loading-parent--relative');
    }

    el.domVisible = true;
    el.appendChild(el.mask);
    el.instance.visible = true;
    el.domInserted = true;
  } else if (el.domVisible && el.instance.hiding === true) {
    el.instance.visible = true;
    el.instance.hiding = false;
  }
}
function toggleLoading(el, {
  value
}) {
  if (value) {
    el.originalPosition = el.style.position;
    insertDom(el);
  } else {
    el.instance.visible = false;
    el.instance.hiding = true;
    const unwatch = el.instance.$watch('hiding', () => {
      if (!el.instance.hiding) {
        el.domVisible = false;
        el.classList.remove('pendo-loading-parent--relative');
        unwatch();
      }
    });
  }
}
function createLoader(el, {
  arg,
  value
}) {
  const data = _objectSpread({}, getOptions(_objectSpread({
    type: arg || 'skeleton'
  }, value)));

  const loader = new Loader({
    el: document.createElement('div'),
    data
  });
  el.instance = loader;
  el.mask = loader.$el;
  return el;
}
function bind(el, {
  arg,
  value
}) {
  const isLoading = getLoadingValue(value);
  const loader = createLoader(el, {
    arg,
    value
  });
  isLoading && toggleLoading(loader, {
    value: true
  });
}

function setContainerSize({
  el
}) {
  requestAnimationFrame(() => {
    let height = el.clientHeight;
    let width = el.clientWidth;

    if (el.instance.type === 'skeleton') {
      height = get(el.instance, 'skeletonProps.height', el.parentElement ? el.parentElement.clientHeight : el.clientHeight);
      width = get(el.instance, 'skeletonProps.width', el.parentElement ? el.parentElement.clientWidth : el.clientWidth);
    }

    el.instance.setContainerSize({
      height,
      width
    });
  });
}

function inserted(el, {
  value
}) {
  const currentValue = getLoadingValue(value);

  if (currentValue) {
    setContainerSize({
      el
    });
  }
}
function update(el, {
  oldValue,
  value
}) {
  if (isEqual(oldValue, value)) {
    return;
  }

  const currentValue = getLoadingValue(value);

  if (currentValue) {
    setContainerSize({
      el
    });
  }

  return toggleLoading(el, {
    value: currentValue
  });
}
function unbind(el) {
  if (el.domInserted) {
    el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
    toggleLoading(el, {
      value: false
    });
  }

  el.instance && el.instance.$destroy();
}
const PendoLoading = {
  options: LOADING_DEFAULTS,
  bind,
  inserted,
  update,
  unbind
};

export { LOADING_DEFAULTS as L, PendoLoading as P, SkeletonLoader as S, getLoadingValue as a, bind as b, createLoader as c, inserted as d, unbind as e, PendoLoading as f, getOptions as g, insertDom as i, toggleLoading as t, update as u };
